module.exports = __webpack_public_path__ + "img/grid-list-view.64eda360.svg";